/* global dataLayer*/
const analytics = () => next => action => {
	window.dataLayer = window.dataLayer || [];
	
	dataLayer.push({
		event: action.type,
		payload: action
	});
	
	return next(action);
};

export default analytics;


// WEBPACK FOOTER //
// ./src/app-analytics.js